import React from 'react'
import Macros from './macros'
import Timeline from './timeline'
import moment from 'moment';

const momentLocalToday = () => {
  const now = moment();
  const nowStr = now.format('YYYY-MM-DD');
  return moment.utc(nowStr);
};

const TrackerPage = (props) => {
  const macroData = props.macroData
  const trackerData = props.trackerData
  const relatedWeighInDateString = props.relatedWeighInDateString
  const selectDate = props.selectDate
  const setShowConsumedMacros = props.setShowConsumedMacros
  const account = props.account
  const daysSinceLastCheckin = momentLocalToday().diff(account.user.lastWeighInDate, 'days');

  return (
    <div className='inspect-page-container inspect'>
      <p style={{ marginBottom: '25px', textAlign: 'center'}}><span style={{ fontWeight: 'bold'}}>{account.user.full_name} ({account.user.email_address})</span></p>
      <div className='stage-content'>
        <Macros macroData={macroData} trackerData={trackerData} relatedWeighInDateString={relatedWeighInDateString} setShowConsumedMacros={setShowConsumedMacros} daysSinceLastCheckin={daysSinceLastCheckin} vacationMode={account.user.vacation_mode} />
        <Timeline macroData={macroData} trackerData={trackerData} selectDate={selectDate} />
      </div>
    </div>
  )
}

export default TrackerPage
